import { useState } from "react";
import "./App.css";

const texts = {
  eyebrow: "ثبت‌نام ویژه",
  title: "تورنومنت روکو",
  lede: "ایمیل خود را وارد کنید، قوانین را تایید کنید و وارد گام نهایی ثبت‌نام شوید.",
  email: "ایمیل",
  rules: "قوانین و مقررات روکو را می‌پذیرم.",
  loading: "در حال ارسال...",
  submit: "ارسال و نمایش نتیجه",
  emailRequired: "ایمیل را وارد کنید.",
  rulesRequired: "تایید قوانین الزامی است.",
  fallbackError: "خطا در ثبت‌نام. لطفاً دوباره تلاش کنید.",
  networkError: "اتصال برقرار نشد. کمی بعد تلاش کنید.",
};

const endpointUrl = "https://rocomiddleware.xyz/api/v1/tournament/submitUserInfo";
const rulesPdfUrl = encodeURI("/مقرارت و شرایط چالش معاملاتی.pdf");

function translateError(payload, emailValue) {
  const message = (payload?.message || "").toString();
  const data = payload?.data;
  const lowerMessage = message.toLowerCase();

  if (message === "validation_error") {
    const items = Array.isArray(data) ? data : [];
    const normalized = items.map((item) => (item || "").toLowerCase());
    const parts = [];
    if (normalized.some((item) => item.includes("cant be empty"))) {
      parts.push(texts.emailRequired);
    }
    if (normalized.some((item) => item.includes("invalid email format"))) {
      parts.push("فرمت ایمیل معتبر نیست.");
    }
    return parts.join(" - ") || "لطفاً ایمیل معتبر وارد کنید.";
  }

  if (lowerMessage.includes("not in the approved list")) {
    return `متاسفانه در حال حاضر ایمیل ${emailValue || ""} تایید نشده است.اگر به تازگی ثبت نام کرده اید لطفا دقایقی بعد مجددا تلاش کنید.`.trim();
  }

  if (lowerMessage.includes("already registered")) {
    return `ایمیل ${emailValue || ""} قبلاً ثبت شده است.`.trim();
  }

  if (lowerMessage.includes("error creating mt5 account")) {
    return "خطا در ایجاد حساب MT5. لطفاً دوباره تلاش کنید.";
  }

  if (lowerMessage.includes("error depositing to mt5 account")) {
    return "خطا در واریز به حساب MT5. لطفاً کمی بعد دوباره تلاش کنید.";
  }

  return message || texts.fallbackError;
}

function App() {
  const [email, setEmail] = useState("");
  const [accepted, setAccepted] = useState(false);
  const [error, setError] = useState("");
  const [htmlContent, setHtmlContent] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setHtmlContent("");
    if (!email.trim()) {
      setError(texts.emailRequired);
      return;
    }
    if (!accepted) {
      setError(texts.rulesRequired);
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(endpointUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-API-Key": "0uaB4ved9jYXS1eAdIYgVZjjwfwy5XQA",
        },
        body: JSON.stringify({ email }),
      });
      const contentType = response.headers.get("content-type") || "";
      const text = await response.text();

      if (!response.ok) {
        let friendly = "";
        if (contentType.includes("application/json")) {
          try {
            const parsed = JSON.parse(text || "{}");
            friendly = translateError(parsed, email);
          } catch (err) {
            friendly = translateError({ message: text }, email);
          }
        } else {
          friendly = translateError({ message: text }, email);
        }
        setError(friendly || texts.fallbackError);
        return;
      }

      setError("");
      if (contentType.includes("text/html")) {
        setHtmlContent(text);
      } else {
        setHtmlContent(text || "");
      }
    } catch (err) {
      setError(texts.networkError);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page" dir="rtl">
      <div className="halo halo-1" />
      <div className="halo halo-2" />
      <div className="shell">
        <div className="card">
          <div className="card-header">
            {/* <div className="badge">ROCO</div> */}
            {/* <p className="eyebrow">{texts.eyebrow}</p> */}
            <h1 style={{ textAlign: "center" }}>{texts.title}</h1>
            <p className="lede">{texts.lede}</p>
          </div>
          <form className="form" onSubmit={handleSubmit}>
            <label className="label" htmlFor="email">
              {texts.email}
            </label>
            <div className="input-wrap">
              <input
                id="email"
                name="email"
                type="email"
                inputMode="email"
                placeholder="example@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                dir="ltr"
              />
            </div>
            <a
              href={rulesPdfUrl}
              target="_blank"
              rel="noreferrer"
              style={{ color: "#0d6efd", textDecoration: "underline", cursor: "pointer" }}
            >
              قوانین و مقررات
            </a>
            <label className="checkbox">
              <input
                type="checkbox"
                checked={accepted}
                onChange={(e) => setAccepted(e.target.checked)}
              />
              <span>{texts.rules}</span>
            </label>
            {error ? <div className="alert">{error}</div> : null}
            <button type="submit" className="submit" disabled={loading}>
              {loading ? texts.loading : texts.submit}
            </button>
          </form>
        </div>
        {htmlContent ? (
          <div className="result">
            <div className="result-title">نتیجه ثبت‌نام</div>
            <div className="result-body" dangerouslySetInnerHTML={{ __html: htmlContent }} />
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default App;
